<div>
  <form [formGroup]="visitorLimitForm" class="forms-sample">
    <div class="form-group">
      <label for="maxInsiders">
        {{'SETTINGS.VISITOR_LIMIT.MAX_INSIDERS' | translate}}
      </label>
      <input type="number" min="0" class="form-control" formControlName="maxInsiders" id="maxInsiders" >
    </div>

    <div class="form-group">
      <label for="alertLimit">
        {{'SETTINGS.VISITOR_LIMIT.ALERT_LIMIT' | translate}}
      </label>
      <input type="number" class="form-control" formControlName="alertLimit" id="alertLimit" >
    </div>
  </form>
</div>
